export { default as ProductPage } from './View';
export type { ViewProps as ProductPageProps } from './View';
